import React, { useEffect, useId, useState } from 'react';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getAllTicket } from '../api/ticketApi';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
// import OneSignal from 'react-onesignal';
import { encryptPayload } from '../utils/encryption';

export default function Login() {
  const navigate = useNavigate();
  const deviceId = useId();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

  if (isAndroid) {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.fxmaster";
  } else if (isIOS) {
    window.location.href =
      "https://apps.apple.com/in/app/fxmaster-money-transfer/id6472921073";
  }
}, []);
  
    const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const encryptedPayload = await encryptPayload({
          email: username,
          password: password,
          appversion: 1,
          platform: 'web',
          extraParamValidation: 'trustedfromweb'
        });

    await axios
      .post(
        Constants.BASE_URL + 'API-FX-120-Login',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then(async(resp) => {
        // console.log('resp', resp);
        // console.log(JSON.stringify(resp.data));
        loadAppDefault();
        loadcountries();
        const isKycLater = resp.data.data.addresses?.[0]?.address === 'PENDING_KYC_LATER';
          setAsyncData('kyc_pending_later', isKycLater ? 'true' : 'false');
          isKycLater && setAsyncData("enterPin", password);

        try {
          const dropResp = await axios.get(
            Constants.BASE_URL +
              'API-FX-160-DROPSCREENDETAILS?user-id=' +
              resp.data.data.id,
            { headers: { fx_key: Constants.SUBSCRIPTION_KEY, Authorization: 'Bearer '+ resp.data.token } },
          );
          // console.log('FULL 160 response:', dropResp.data);
          if (dropResp.data && dropResp.data.length > 0) {
            sessionStorage.setItem('userid', JSON.stringify(dropResp.data[0].user_id));
            sessionStorage.setItem('deviceid', dropResp.data[0].device_id);
          }
          const nationalityScreen = dropResp.data.find((s)=>s.screen_name === 'NATIONALITY_2')
          const registrationToken = nationalityScreen?.meta?.registrationToken
          if(registrationToken){
            sessionStorage.setItem("registrationToken",registrationToken)
          }
          const dobScreen = dropResp.data.find(
            (s) => s.screen_name === 'DOB_ADDRESS_5',
          );
          console.log('matched dobScreen:', dobScreen);
          // sessionStorage.setItem(
          //   'kyc_pending_later',
          //   dobScreen?.meta?.kyc_status === 'Later' ? 'true' : 'false',
          // );
          setAsyncData("enterPin", password);
        } catch (kycErr) {
          console.log('kyc status check failed', kycErr?.response?.data);
          sessionStorage.setItem('kyc_pending_later', 'false');
        }

        
          localStorage.removeItem('fx_remember');
          localStorage.removeItem('fx_email');
          localStorage.removeItem('fx_password');
        
        if (resp.data.data.registration_step == 'account_preview') {
          onHandle(resp.data.data.email);
          setAsyncData('login_id', JSON.stringify(resp.data.data.id));
          setAsyncData('login_full_name', resp.data.data.full_name);
          setAsyncData('login_email', resp.data.data.email);
          setAsyncData('login_phone', resp.data.data.phone);
          setAsyncData('login_date_of_birth', resp.data.data.date_of_birth);
          setAsyncData('login_country_code', resp.data.data.country_code);
          setAsyncData(
            'login_country_id',
            JSON.stringify(resp.data.data.country_id),
          );
          setAsyncData('login_country_name', resp.data.data.country_name);
          setAsyncData('login_nationality', resp.data.data.nationality);
          setAsyncData(
            'login_registration_step',
            resp.data.data.registration_step,
          );
          setAsyncData(
            'login_is_banking_user',
            JSON.stringify(resp.data.data.is_banking_user),
          );
          setAsyncData('login_status', resp.data.data.status);
          setAsyncData('login_yoti_status', resp.data.data.yoti_status);
          setAsyncData(
            'login_workspaces',
            JSON.stringify(resp.data.data.workspaces),
          );
          setAsyncData(
            'login_workspace_name',
            (resp.data.data.workspaces[0].name),
          );
          setAsyncData(
            'login_workspaces_id',
            JSON.stringify(resp.data.data.workspaces[0].id),
          );
          setAsyncData('login_token', JSON.stringify(resp.data.token));
          setAsyncData(
            'login_address',
            JSON.stringify(
              resp.data.data.addresses[0].address +
                resp.data.data.addresses[0].street,
            ),
          );
          setAsyncData(
            'login_postcode',
            JSON.stringify(resp.data.data.addresses[0].postcode),
          );
          setAsyncData(
            'login_city',
            JSON.stringify(resp.data.data.addresses[0].city),
          );
          // console.log(resp.data.default_bank);
          if (
            resp.data.default_bank.length > 0 &&
            resp.data.default_bank[0] != 'CC as Service'
          ) {
            setAsyncData('defaultBank', resp.data.default_bank[0]);
            setAsyncData(
              'clearBankCustomerId',
              resp.data.clear_bank_data[0].customer_id,
            );
            setAsyncData(
              'clearBankCustomerBankCode',
              resp.data.clear_bank_data[0].meta.bank[0].BankCode,
            );
            setAsyncData(
              'clearBankCustomerIBAN',
              resp.data.clear_bank_data[0].meta.bank[0].IBAN,
            );
            setAsyncData(
              'clearBankCustomerWalletId',
              resp.data.clear_bank_data[0].meta.bank[0].WalletId,
            );
            setAsyncData(
              'clearBankCustomerSWIFTCode',
              resp.data.clear_bank_data[0].meta.bank[0].SWIFTCode,
            );
            setAsyncData(
              'clearBankCustomerAccountName',
              resp.data.clear_bank_data[0].meta.bank[0].AccountName,
            );
            setAsyncData(
              'clearBankCustomerWalletNumber',
              resp.data.clear_bank_data[0].meta.bank[0].WalletNumber,
            );
            setAsyncData(
              'clearBankCustomerSortCode',
              resp.data.clear_bank_data[0].meta.bank[0].sortCode,
            );
            setAsyncData(
              'clearBankCustomerServiceProviderAccountId',
              resp.data.clear_bank_data[0].meta.bank[0]
                .ServiceProviderAccountId,
            );
          } else {
            setAsyncData('defaultBank', 'CC as Service');
            setAsyncData('clearBankCustomerId', '');
          }
          setAsyncData('kyc_submitted', 'true');
          // setLoading(false);
          setAsyncData('login_id', JSON.stringify(resp.data.data.id));
          // console.log("rrrrr" + resp.data.data.id);
          setAsyncData('re_kyc', JSON.stringify(resp.data.need_rekyc));

          const account = resp.data.data.workspaces[0].type;
          sessionStorage.setItem('account_type', account);
          await checkHiddenWallets(resp.data.data.workspaces[0].id, resp.data.token);
          if (resp.data.need_rekyc == 0) {
            const workspace_id = sessionStorage.getItem('login_workspaces_id');
            getAllTicket(workspace_id)
              .then((data) => {
                const backendIdsAtLogin = data.results
                  .filter((ticket) => ticket.assign_to !== null)
                  .map((ticket) => ticket.id);
                //console.log('back', backendIdsAtLogin);
                localStorage.setItem(
                  'backendTicketIdsAtLogin',
                  JSON.stringify(backendIdsAtLogin),
                );
                if (resp.data.data.two_fa_login == 1) {
                  setAsyncData('two_fa', resp.data.data.two_fa_login);
                  setAsyncData('qr_enabled', resp.data.data.qr_enabled);
                  generateQr(
                    resp.data.data.workspaces[0].id,
                    resp.data.data.workspaces[0].email,
                    resp.data.data.qr_enabled,
                    resp.data.data.id,
                  );
                } else {
                  const account = resp.data.data.workspaces[0].type;
                  sessionStorage.setItem('account_type', account);
                  navigate(account === 'business' ? '/' : '/SendMoneyTab', {
                    state: { qr_login_completed: 1 },
                  });
                }
              })
              .catch((err) => {
                console.error('Ticket fetch error:', err);
                setLoading(false)
                // Optionally handle error UI
              });
              return;
          } else {
            navigate('/sumsubReKyc');
          }
          
          const isKycLater = resp.data.data.addresses?.[0]?.address === 'PENDING_KYC_LATER';
          setAsyncData('kyc_pending_later', isKycLater ? 'true' : 'false');
          isKycLater && setAsyncData("enterPin", password);
          sessionStorage.setItem('shouldInitOneSignal', 'true');
          if (resp.data.need_rekyc == 0) {
              if (resp.data.data.two_fa_login == 1) {
                setAsyncData('two_fa', resp.data.data.two_fa_login);
                setAsyncData('qr_enabled', resp.data.data.qr_enabled);
                generateQr(
                  resp.data.data.workspaces[0].id,
                  resp.data.data.workspaces[0].email,
                  resp.data.data.qr_enabled,
                  resp.data.data.id,
                );
              } else {
                const account_type = sessionStorage.getItem('account_type');
                navigate(account_type === 'business' ? '/' : '/SendMoneyTab', {
                  state: { qr_login_completed: 1 },
                });
              }
          } else navigate('/sumsubReKyc');
        } else {
          dropscreens(resp.data.data.id, password, resp.data.token);
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        // console.log('here');
        // console.log(JSON.stringify(err.response));
        setError(err.response.data.message);
        // setPin("");
        setLoading(false);
      });
  };

  const checkHiddenWallets = async (workspaceId, token) => {
    console.log('workspaceId',workspaceId);
    console.log('token',token);
    sessionStorage.setItem('hide_gbp_wallets', 'false');
    // API-FX-253 can return a success body with a non-2xx status, so check the body in both then and catch
    const applyHiddenWallets = (data) => {
      const sessionWorkspaceId = sessionStorage.getItem('login_workspaces_id');
      console.log('sessionWorkspaceId',sessionWorkspaceId);
      if (data?.success && Array.isArray(data.data)) {
        const isHidden = data.data.some(
          (wallet) => String(wallet.workspace_id) === String(sessionWorkspaceId),
        );
        sessionStorage.setItem('hide_gbp_wallets', isHidden ? 'true' : 'false');
      }
    };
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-253-GET-HIDDEN-WALLETS',
        {
          workspace_id: workspaceId,
        },
        {
          headers: {
            Authorization: 'Bearer ' + token,
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        console.log('respcccc',resp);
        applyHiddenWallets(resp.data);
      })
      .catch((err) => {
        console.log(err.response?.data || err.message);
        applyHiddenWallets(err.response?.data);
      });
  };
  
  const generateQr = async (workspace, email, qrEnabled, userId) => {
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-244-GENERATE-LOGIN-QR',
        {
          workspace: workspace,
          email: email,
        },
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            'Content-Type': 'application/json',
          },
          auth: {
            username: Constants.REPORTS_USER_NAME,
            password: Constants.REPORTS_PASSWORD,
          },
        },
      )
      .then((resp) => {
        navigate('/verify-2fa', {
          state: {
            qr: resp.data,
            qrEnabled: qrEnabled,
            userId: userId,
            workspace: workspace,
          },
        });
      })
      .catch((err) => {
        console.log(err.response?.data || err.message);
      });
  };
  const loadcountries = async () => {
    await axios
      .get(Constants.BASE_URL + 'API-FX-102-Country', {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      })
      .then((response) => {
        // console.log('response', response);
        setAsyncData('countries', JSON.stringify(response.data.data));
      })
      .catch((error) => {
        console.log('countr' + error.response.data);
      });
  };
  const loadAppDefault = async () => {
    await axios
      .get(Constants.BASE_URL + 'API-FX-100-App', {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      })
      .then((response) => {
        // console.log('response', response);
        setAsyncData(
          'transfer_reasons',
          JSON.stringify(response.data.data.transfer_reasons),
        );
      })
      .catch((error) => {
        console.log('app' + error.response);
      });
  };
  const dropscreens = async (userid, pin, token) => {
    setAsyncData('enterPin', pin);
    await axios
      .get(
        Constants.BASE_URL + 'API-FX-160-DROPSCREENDETAILS?user-id=' + userid,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer '+token
          },
        },
      )
      .then((dropresp) => {
        // console.log('dropresp', dropresp.data);
        var pagename = '';
        setAsyncData(
              'registrationToken',
              token,
            );
        for (var d = 0; d < dropresp.data.length; d++) {
          // console.log(dropresp.data[d].screen_name);

          if (dropresp.data[d].screen_name == 'NATIONALITY_2') {
            setAsyncData('userid', JSON.stringify(userid));
            setAsyncData('user_full_name', dropresp.data[d].meta.first_name);
            setAsyncData('user_email', dropresp.data[d].meta.email);
            setAsyncData('user_phone', dropresp.data[d].meta.phone);
            setAsyncData('login_phone', dropresp.data[d].meta.phone);
            setAsyncData('user_first_name', dropresp.data[d].meta.first_name);
            setAsyncData('user_middle_name', dropresp.data[d].meta.middle_name);
            setAsyncData('user_last_name', dropresp.data[d].meta.last_name);
            setAsyncData(
              'user_country_code',
              dropresp.data[d].meta.country_code,
            );
            setAsyncData('user_country_id', dropresp.data[d].meta.country_id);
            
            setAsyncData('deviceid', deviceId);
            setAsyncData('firstName', dropresp.data[d].meta.first_name);
            setAsyncData('middleName', dropresp.data[d].meta.middle_name);
            setAsyncData('lastName', dropresp.data[d].meta.last_name);
            setAsyncData(
              'registrationType',
              dropresp.data[d].meta.registrationType,
            );
            pagename = 'VerifyPhone';
          }
          if (dropresp.data[d].screen_name == 'MOBILE_OTP_3') {
            pagename = 'VerifyEmail';
          }
          if (dropresp.data[d].screen_name == 'EMAIL_OTP_4') {
            pagename = 'SumSubRegister';
          }
          if (dropresp.data[d].screen_name == 'DOB_ADDRESS_5') {
            // setAsyncData("yotisessionID", dropresp.data[d].meta.yotisessionID);
            // setAsyncData("yotisessionToken", dropresp.data[d].meta.yotisessionToken);
            // setAsyncData("yotiurl", dropresp.data[d].meta.yotiurl);

            // console.log(dropresp.data[d].meta.regType);
            if (
              dropresp.data[d].meta.regType === 'personal' ||
              dropresp.data[d].meta.regType === 'individual'
            ) {
              pagename = 'ApplicationPreview';
            } else {
              pagename = 'BusinessDetails';
            }
          }
          if (dropresp.data[d].screen_name == 'BUSINESS_DETAILS_6') {
            setAsyncData('activity', dropresp.data[d].meta.activity);
            setAsyncData('turnover', dropresp.data[d].meta.turnover);
            setAsyncData(
              'selectedAddress',
              dropresp.data[d].meta.selectedAddress,
            );
            setAsyncData(
              'selectedcompanyName',
              dropresp.data[d].meta.selectedcompanyName,
            );
            setAsyncData(
              'selectedcompanyNumber',
              dropresp.data[d].meta.selectedcompanyNumber,
            );
            setAsyncData(
              'selectedcompanyAddress',
              dropresp.data[d].meta.selectedcompanyAddress,
            );
            setAsyncData(
              'selectedcompanyPostalCode',
              dropresp.data[d].meta.selectedcompanyPostalCode,
            );
            setAsyncData(
              'selectedcompanyStatus',
              dropresp.data[d].meta.selectedcompanyStatus,
            );
            setAsyncData(
              'selectedcompanyCountry',
              dropresp.data[d].meta.selectedcompanyCountry,
            );
            setAsyncData(
              'selectedcompanyStreet',
              dropresp.data[d].meta.selectedcompanyStreet,
            );
            setAsyncData(
              'selectedcompanyHouseNumber',
              dropresp.data[d].meta.selectedcompanyHouseNumber,
            );
            pagename = 'AboutBusiness';
          }
          if (dropresp.data[d].screen_name == 'ABOUT_BUSINESS_7') {
            setAsyncData('businessWebsite', dropresp.data[d].meta.website);
            setAsyncData('businessEmail', dropresp.data[d].meta.email);
            setAsyncData('businessPhone', dropresp.data[d].meta.phone);
            setAsyncData('businessAbout', dropresp.data[d].meta.about);
            pagename = 'BusinessAddress';
          }
          if (dropresp.data[d].screen_name == 'BUSINESS_ADDRESS_8') {
            pagename = 'SelectOfficer';
          }
          if (dropresp.data[d].screen_name == 'SELECT_OFFICER_9') {
            setAsyncData('enterPin', pin);
            pagename = 'ApplicationPreview';
          }
          if (dropresp.data[d].screen_name == 'YOTI_COMPLETED_6') {
            setAsyncData('enterPin', pin);
            pagename = 'ApplicationPreview';
          }
        }
        if (pagename != '' && pagename != null) {
          // console.log('final ' + pagename);
          // const account_type = sessionStorage.getItem('account_type');
          navigate('/' + pagename,
            { state: { pin: password } },
          );
        }
        setLoading(false);
      })
      .catch((droperr) => {
        console.log(droperr.response.data);
        setLoading(false);
      });
  };
  const setAsyncData = async (key, value) => {
    // console.log('key', key);
    // console.log('value', value);
    sessionStorage.removeItem('yotiurl');
    sessionStorage.removeItem('totalprocessingurl');
    sessionStorage.setItem(key, value);
  };

  const onHandle = async (email) => {
    // OneSignal.User.addTag('login',email)
    console.log(email);
  };

  return (
  <div
    className="w-screen min-h-screen bg-cover bg-center bg-no-repeat flex justify-center lg:justify-end items-center px-4 sm:px-6 md:px-8 lg:px-0 py-6"
    style={{
      backgroundImage: 'url("/loginscreen.png")',
    }}
  >
    <div className="w-full lg:w-1/2 h-full flex justify-center items-center lg:px-10">
      <div className="w-full max-w-[500px] bg-white min-h-[520px] rounded-[12px] px-5 sm:px-8 md:px-10 lg:px-12 py-6 sm:py-8 shadow-2xl">
        <h1 className="text-[#11295A] text-[28px] sm:text-[32px] md:text-[36px] lg:text-[38px] font-bold">
          Welcome Back.
        </h1>

        <p className="mt-2 text-[14px] sm:text-[15px] md:text-[16px] lg:text-[17px] text-[#1A1A1A]">
            New to FXMaster ?{' '}
            <button
              onClick={() => navigate('/account-type')}
              className="underline font-semibold"
            >
              Signup
            </button>
          </p>

        <div>
            <label className="block text-[#11295A] text-[15px] sm:text-[16px] lg:text-[17px] font-semibold mt-8 sm:mt-10 -mb-3">
              Email ID
            </label>

          <div className="relative">
            <input
              type="text"
              placeholder="Enter your Email ID"
              className="w-full h-[52px] sm:h-[58px] border border-[#BCC3D3] rounded-[10px] px-4 sm:px-5 outline-none bg-white mt-5"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <label className="block text-[#11295A] text-[15px] sm:text-[16px] lg:text-[17px] font-semibold mt-8 sm:mt-4 mb-2">
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              className="w-full h-[52px] sm:h-[58px] border border-[#BCC3D3] rounded-[10px] px-4 sm:px-5 outline-none bg-white"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="button"
              className="absolute mt-7 right-4 sm:right-5 -translate-y-1/2 text-[#555]"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <AiOutlineEyeInvisible size={20} />
              ) : (
                <AiOutlineEye size={20} />
              )}
            </button>
          </div>

          <div className="flex justify-end mt-2">
            <button
              onClick={() => navigate("/forgotPin")}
              className="text-[13px] sm:text-[14px] text-[#555555] font-medium"
            >
              Forgot Password?
            </button>
          </div>
        </div>

        {error && (
          <div className="w-full mt-3 text-center text-red-500 text-sm font-medium">
            {error}
          </div>
        )}

        <button
          onClick={handleLogin}
          className="w-full h-[56px] sm:h-[60px] lg:h-[64px] mt-8 bg-[#D9681D] rounded-[14px] text-white text-[18px] sm:text-[20px] lg:text-[24px] font-semibold flex items-center justify-center gap-3"
        >
          {loading ? "Loading..." : "Login"}
        </button>
      </div>
    </div>
  </div>
);
}